import React from 'react';
import {Icon} from 'bonprix-design-system';
import {XRay} from '@teaser/scripts/components/XRay.jsx';

/**
 * @param {string} text
 * @param {string} [fieldId]
 * @returns {JSX.Element}
 */
export function CallToAction({text, fieldId = 'callToAction'}) {
    if (!text) return null;

    return (
        <div className="content-platform__teaser__cta_wrapper -show-only-on-desktop">
            <XRay fieldId={fieldId} />
            <div className="content-platform__teaser__primary_cta -aop">
                {text}
                <Icon className="fill-white w-4 h-4" variant="arrow-right" />
            </div>
        </div>
    );
}
